module.exports = __webpack_public_path__ + "static/14-Basketball-Court-View-e4239f6615e16521e3c70f21a9a0ae96.jpeg";